import React from "react";

export const LazyResearchEvaluationBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "ResearchEvaluation" */ "./ResearchEvaluation"
        )
);
